module.exports = __webpack_public_path__ + "img/ecology3.d80fcef9.jpeg";